import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/icon-line-introduction.png'


const _hoisted_1 = {
  key: 0,
  class: "wrapper-text container"
}
const _hoisted_2 = { class: "panels" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  ref: "breadcrumbImg",
  class: "breadcrumb-img"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "introduction-nav"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = {
  class: "nav",
  ref: "nav"
}
const _hoisted_9 = {
  key: 0,
  class: "prev"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "screen-reader" }
const _hoisted_12 = {
  key: 1,
  class: "next"
}
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "screen-reader" }
const _hoisted_15 = {
  key: 2,
  class: "next"
}
const _hoisted_16 = { class: "screen-reader" }
const _hoisted_17 = {
  key: 2,
  class: "continue-experience wrapper-text container"
}
const _hoisted_18 = { class: "wrapper" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_20 = { class: "nav" }
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  class: "intro-3-backgrounds",
  ref: "intro3Backgrounds"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "frame frame-1",
  role: "presentation"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "frame frame-2",
  role: "presentation"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "frame frame-3",
  role: "presentation"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "frame frame-4",
  role: "presentation"
}, null, -1)
const _hoisted_27 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoMain = _resolveComponent("LogoMain")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["introduction-page", _ctx.panelCounterClass])
  }, [
    _createVNode(_component_MainLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_LogoMain),
        (!_ctx.experienceCookie)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panels, (panel, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (_ctx.panelIndex === index)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["panel", _ctx.panelCounterClass])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getContent(panel), (p, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "group",
                                  innerHTML: p,
                                  key: index
                                }, null, 8, _hoisted_3))
                              }), 128)),
                              _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: _normalizeClass('breadcrumb_' + index)
                                  }, [
                                    _createElementVNode("img", {
                                      src: theme.introBreadcrumb,
                                      alt: ""
                                    }, null, 8, _hoisted_5)
                                  ], 2))
                                }), 128))
                              ], 512)
                            ], 2))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.experienceCookie)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  (_ctx.panelIndex !== 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "button",
                          class: "btn-nav prev",
                          title: _ctx.previousSlideTranslation,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevPanel()))
                        }, [
                          _withDirectives(_createElementVNode("span", _hoisted_11, null, 512), [
                            [_directive_translate, `introduction.slide_previous`]
                          ])
                        ], 8, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.panelIndex !== (_ctx.panels.length -1))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "button",
                          class: "btn-nav next",
                          title: _ctx.nextSlideTranslation,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPanel()))
                        }, [
                          _withDirectives(_createElementVNode("span", _hoisted_14, null, 512), [
                            [_directive_translate, `introduction.slide_next`]
                          ])
                        ], 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.panelIndex === (_ctx.panels.length - 1))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          class: "btn-nav next",
                          title: _ctx.startExperienceTranslation,
                          to: { name: 'ThemesPage', params: { lang: _ctx.$i18n.locale } },
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.completeExperience(false)))
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("span", _hoisted_16, null, 512), [
                              [_directive_translate, `introduction.experience_start`]
                            ])
                          ]),
                          _: 1
                        }, 8, ["title", "to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.experienceCookie === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_translate, `introduction.existing_experience_message`]
                ])
              ]),
              _createElementVNode("ul", _hoisted_20, [
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("button", {
                    type: "button",
                    role: "button",
                    class: "btn",
                    title: _ctx.restartExperienceTranslation,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetExperience()))
                  }, null, 8, _hoisted_21), [
                    [_directive_translate, `introduction.experience_restart`]
                  ])
                ]),
                _createElementVNode("li", null, [
                  _withDirectives(_createVNode(_component_router_link, {
                    title: _ctx.continueExperienceTranslation,
                    class: "btn",
                    to: { name: 'ThemesPage', params: { lang: _ctx.$i18n.locale } },
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.completeExperience(true)))
                  }, null, 8, ["title", "to"]), [
                    [_directive_translate, `introduction.experience_continue`]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_22, _hoisted_27, 512)
  ], 2))
}